import Button from "@/components/atom/Button";
import Divider from "@/components/atom/Divider";
import currency from "@/functions/currency";
import { ArrowUpSvg, ChevronUpSvg } from "@/public/svg";
import { useMemo, useState } from "react";

export default function HistoryComission({ datas = [] }) {
  const [isFiveBestSeller, setIsFiveBestSeller] = useState(5);
  const isdatas = useMemo(() => {
    return datas.slice(0, isFiveBestSeller);
  }, [datas?.length, isFiveBestSeller]);

  return (
    <div className=" bg-shadesGON-50 shadow-normalGON rounded-2xl ">
      <div className="flex flex-col gap-3 xs:gap-6 p-4 xs:p-8">
        <div className="flex flex-col gap-2 border-b border-b-greyscaleGON-200 pb-4">
          <p className="subheading-semiBold text-greyscaleGON-700">
            History Komisi
          </p>
          <p className="p2-regular sm:p1-regular text-greyscaleGON-400">
            Menampilkan history komisi
          </p>
        </div>
      </div>
      <div className="flex flex-col">
        {isdatas?.map((item, index) => {
          const isDate = item?.date?.split(" ");
          return (
            <div key={index} className="md:border-b-0 border-b pb-2 mb-2 flex">
              <div className="flex flex-row items-start justify-between w-full px-4 xs:px-8 ">
                <div className="flex items-start gap-3 w-full">
                  <p className="text-button-medium text-greyscaleGON-700">
                    {index + 1}.
                  </p>
                  <div className="flex flex-col gap-1">
                    <p className="text-button-medium text-greyscaleGON-700">
                      {`${isDate[4]} ${isDate[5]}`}
                    </p>
                    <p className="p3-medium text-greyscaleGON-400">
                      {item?.kode_order}
                    </p>
                    <p className="text-button-small text-greyscaleGON-600">
                      order {item?.sum_products} products
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3 w-full justify-end">
                  <div className="p-2 bg-successGON-50 rounded-full">
                    <ArrowUpSvg className="h-4 w-4 text-successGON-600" />
                  </div>
                  <p className="p1-medium text-greyscaleGON-500">
                    {currency(item?.total_price_comsision_db ?? 0)}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
        {isFiveBestSeller < datas.length && (
          <div>
            <Button
              label={"Lihat lainnya"}
              variants="outline"
              onClick={() => setIsFiveBestSeller((old) => old + 5)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
